import { Navigate, Route, Routes } from 'react-router-dom'
import { PipelinesPage } from '../tfi/pages/pipelines/PipelinesPage'
import NotFoundPage from '../tfi/pages/notFound/NotFoundPage'
import { LeadsPage } from '../tfi/pages/leads/LeadsPage'
import { LeadLossReasonPage } from '../tfi/pages/leadLossReason/LeadLossReasonPage'
import { TagManagerPage } from '../tfi/pages/tagManager/TagManagerPage'
import { MembersPage } from '../tfi/pages/members/MembersPage'
import { AssignmentGroupsPage } from '../tfi/pages/assignmentGroups/AssignmentGroupsPage'
import { LeadSourcePage } from '../tfi/pages/leadSource/LeadSourcePage'
import { PolicyStatusPage } from '../tfi/pages/policyStatus/PolicyStatusPage'
import { StatesEUPage } from '../tfi/pages/statesEU/StatesEUPage'
import { PolicyTypePage } from '../tfi/pages/policyType/PolicyTypePage'
import { OneLeadPage } from '../tfi/pages/oneLead/OneLeadPage'
import { OneAddQuotePage } from '../tfi/pages/oneAddQuote/OneAddQuotePage'
import { OnePolicyPage } from '../tfi/pages/onePolicy/OnePolicyPage'
import { UsersPage } from '../tfi/pages/users/UsersPage'
import { PoliciesPage } from '../tfi/pages/policies/PoliciesPage'
import { CarriersPage } from '../tfi/pages/carriers/CarriersPage'
import { OneUserPage } from '../tfi/pages/oneUser/OneUserPage'
import { OneComissionRate } from '../tfi/pages/oneCarrier/OneComissionRate'
import { useGetUser } from '../tfi/store/userStore'
import { hasPermission, canViewBilling } from '../tfi/helpers'
import { ALL_PERMISSIONS } from '../tfi/helpers/consts'
import { IntegrationsPage } from '../tfi/pages/integrations/IntegrationsPage'
import { InboxPage } from '../tfi/pages/chat/InboxPage'
import { InboxPage as GmailInboxPage } from '../tfi/pages/inbox/InboxPage'
import { PolicyChatPage } from '../tfi/pages/policyChat/PolicyChatPage'
import { ChannelConfigPage } from '../tfi/pages/channelConfig/ChannelConfigPage'
import { NumbersPage } from '../tfi/pages/numbers/NumbersPage'
import { TwilioBillingPage } from '../tfi/pages/twilioBilling/TwilioBillingPage'
import { BillingPage } from '../tfi/pages/billing/BillingPage'
import { OrganizationsPage } from '../tfi/pages/organizations/OrganizationsPage'
import { OneOrganizationPage } from '../tfi/pages/organizations/OneOrganizationPage'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { ProfilePage } from '../tfi/pages/profile/ProfilePage'
import { NewDashboardPage } from '../tfi/pages/homeReportsPolicies/NewDashboardPage'
import { ExecutiveDashboardPage } from '../tfi/pages/executiveDashboard/ExecutiveDashboardPage'
import { CommissionReportsPage } from '../tfi/pages/commissionReports/CommissionReportsPage'
import { CommissionReportsDetailsPage } from '../tfi/pages/commissionReportsDetails/CommissionReportsDetailsPage'
import { CommissionReportsPayrollPage } from '../tfi/pages/commissionReportsDetails/CommissionReportsPayrollPage'
import { CommissionReportsPayrollTotalsPage } from '../tfi/pages/commissionReports/CommissionReportsPayrollTotalsPage'
import { CommissionReportsLogsPage } from '../tfi/pages/commissionReportsLogs/CommissionReportsLogsPage'
import { QuotesPage } from '../tfi/pages/quotes/QuotesPage'
import { HomeQuotesPage } from '../tfi/pages/homeReportsQuotes/HomeQuotesPage'
import { MedicareCenterPage } from '../tfi/pages/medicareCenter/MedicareCenterPage'
import { SignatureFormsPage } from '../tfi/pages/signatureForms/SignatureFormsPage'
import { OnboardingPage } from '../tfi/pages/onboarding/OnboardingPage'
import { OnboardingDetailPage } from '../tfi/pages/onboarding/OnboardingDetailPage'
import { SignatureFormsEntriesPage } from '../tfi/pages/signatureFormsEntries/SignatureFormsEntriesPage'
import { PdfEnvelopesPage } from '../tfi/pages/pdfEnvelopes/PdfEnvelopesPage'
import { PdfEnvelopeEntriesPage } from '../tfi/pages/pdfEnvelopeEntries/PdfEnvelopeEntriesPage'
import { ContactsPage } from '../tfi/pages/contacts/ContactsPage'
import { UserDeductionTypePage } from '../tfi/pages/userDeductionType/UserDeductionTypePage'
import { ResourceCenterPage } from '../tfi/pages/resourceCenter/ResourceCenterPage'
import { AcademyPage } from '../tfi/pages/academy/AcademyPage'
import { CoursePlayerPage } from '../tfi/pages/academy/CoursePlayerPage'
import { ManageCoursesPage } from '../tfi/pages/academy/ManageCoursesPage'
import { KanbanPage } from '../tfi/pages/kanban/KanbanPage'
import { CampaignsPage } from '../tfi/pages/campaigns/CampaignsPage'
import { CampaignDetailPage } from '../tfi/pages/campaigns/CampaignDetailPage'
import { CampaignsMediaPage } from '../tfi/pages/campaigns/CampaignsMediaPage'
import { VicidialCampaignsPage } from '../tfi/pages/campaigns/VicidialCampaignsPage'
import { AutoPushRulesPage } from '../tfi/pages/autoPush/AutoPushRulesPage'
import { TelephonySupervisorPage } from '../tfi/pages/telephonySupervisor/TelephonySupervisorPage'
import { MyCallsPage } from '../tfi/pages/myCalls/MyCallsPage'
import { TemplatesPage } from '../tfi/pages/templates/TemplatesPage'
import { TemplateEditorPage } from '../tfi/pages/templates/TemplateEditorPage'
import { RecipientsPage } from '../tfi/pages/recipients/RecipientsPage'
import { WhatsAppTemplatesPage } from '../tfi/pages/integrations/WhatsAppTemplatesPage'
import { NotificationsPageWrapper } from '../tfi/pages/notifications/NotificationsPageWrapper'
import { AutomationsPage } from '../tfi/pages/automations/AutomationsPage'
import { CalendarPage } from '../tfi/pages/calendar/CalendarPage'
import { AttentionTicketsPage } from '../tfi/pages/attentionTickets/AttentionTicketsPage'
import { TicketFormPage } from '../tfi/pages/attentionTickets/TicketFormPage'
import { SystemMonitorPage } from '../tfi/pages/systemMonitor/SystemMonitorPage'
import { PolicytoolsSettingsPage } from '../tfi/pages/policytoolsSettings/PolicytoolsSettingsPage'
import { DifyUsageReportPage } from '../tfi/pages/difyUsageReport/DifyUsageReportPage'
import { canAccessPolicyDashboard, getLandingRoute } from './routeUtils'

const CLIENT_ID = '1005174958588-ht8kplhn013evfjg2de734oc2upk6djp.apps.googleusercontent.com'

export const TFIRoutes = () => {
  const permissions = useGetUser((s) => s.user?.permissions)
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const landingRoute = getLandingRoute({ permissions: permissions || [], userGroups })
  const canViewPolicyDashboard = canAccessPolicyDashboard({
    permissions: permissions || [],
    userGroups,
  })
  return (
    <Routes>
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_PIPELINE) && (
        <Route path='pipelines' element={<PipelinesPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD) && (
        <Route path='leads' element={<LeadsPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD_LOSS_REASON) && (
        <Route path='/lead-loss-reasons' element={<LeadLossReasonPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_TAG_MANAGER) && (
        <Route path='/tag-manager' element={<TagManagerPage />} />
      )}
      {permissions &&
        hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMISSION_DEDUCTION_TYPE) && (
          <Route path='/user-deductions' element={<UserDeductionTypePage />} />
        )}
      <Route path='/members' element={<MembersPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_GROUP_ASSIGNMENT) && (
        <Route path='/assignment-groups' element={<AssignmentGroupsPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD_SOURCE) && (
        <Route path='/lead-sources' element={<LeadSourcePage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY_STATUS) && (
        <Route path='/policy-statuses' element={<PolicyStatusPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_STATE_EU) && (
        <Route path='/states-eu' element={<StatesEUPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY_TYPE) && (
        <Route path='/policy-type-setup' element={<PolicyTypePage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD) && (
        <Route path='/lead/:id' element={<OneLeadPage />} />
      )}
      <Route path='/quote/:id' element={<OneAddQuotePage />} />
      <Route path='/sold' element={<OnePolicyPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_USER) && (
        <Route path='/users' element={<UsersPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_USER) && (
        <Route path='/user/:id' element={<OneUserPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
        <Route path='/policies' element={<PoliciesPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_CARRIER) && (
        <Route path='/carriers' element={<CarriersPage />} />
      )}
      <Route path='/carrier/:id' element={<OneComissionRate />} />

      <Route
        path='/integrations'
        element={
          <GoogleOAuthProvider clientId={CLIENT_ID}>
            <IntegrationsPage />
          </GoogleOAuthProvider>
        }
      />
      <Route path='/integrations/whatsapp-templates' element={<WhatsAppTemplatesPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMUNICATION_LOGS) && (
        <Route path='/inbox' element={<InboxPage />} />
      )}
      <Route path='/email-inbox' element={<GmailInboxPage />} />
      <Route path='/policychat' element={<PolicyChatPage />} />
      <Route path='/channel-config' element={<ChannelConfigPage />} />
      {permissions && canViewBilling(permissions) && (
        <Route path='/billing' element={<BillingPage />} />
      )}
      <Route path='/numbers' element={<NumbersPage />} />
      {/* Misma data que la pestaña "Cost & Usage" de /billing, así que mismo permiso. */}
      {permissions && canViewBilling(permissions) && (
        <Route path='/twilio-billing' element={<TwilioBillingPage />} />
      )}
      <Route path='/dify-usage-report' element={<DifyUsageReportPage />} />
      <Route path='/organizations' element={<OrganizationsPage />} />
      <Route path='/organization/:id' element={<OneOrganizationPage />} />
      <Route path='/profile' element={<ProfilePage />} />
      <Route path='/dashboard/lead' element={<Navigate to={landingRoute} replace />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMISSION) && (
        <Route path='/commissions' element={<CommissionReportsPage />} />
      )}
      <Route path='/commissions/payroll-totals' element={<CommissionReportsPayrollTotalsPage />} />
      <Route path='/commissions/:id/details' element={<CommissionReportsDetailsPage />} />
      <Route path='/commissions/:id/details/:client' element={<CommissionReportsDetailsPage />} />
      <Route path='/commissions/:id/payroll' element={<CommissionReportsPayrollPage />} />
      <Route path='/commissions/:id/conciliation' element={<CommissionReportsLogsPage />} />
      <Route
        path='/dashboard/policy'
        element={
          canViewPolicyDashboard ? <NewDashboardPage /> : <Navigate to={landingRoute} replace />
        }
      />
      <Route path='/dashboard/quote' element={<HomeQuotesPage />} />
      {canViewPolicyDashboard && (
        <Route path='/dashboard/executive' element={<ExecutiveDashboardPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_CONTACT) && (
        <Route path='/medicare-center' element={<MedicareCenterPage />} />
      )}
      {/* <Route path='/one-quote/:id' element={<OneQuotePage />} /> */}
      <Route path='/one-quote/:id' element={<OnePolicyPage />} />
      <Route path='/one-policy/:id' element={<OnePolicyPage />} />
      <Route path='/quotes' element={<QuotesPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_SIGNATURE_FORMS) && (
        <Route path='/signature-forms' element={<SignatureFormsPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_AGENT_ONBOARDING) && (
        <Route path='/onboarding' element={<OnboardingPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_AGENT_ONBOARDING) && (
        <Route path='/onboarding/:id' element={<OnboardingDetailPage />} />
      )}
      <Route path='/signature-forms/:id/entries' element={<SignatureFormsEntriesPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_PDF_ENVELOPES) && (
        <Route path='/pdf-envelopes' element={<PdfEnvelopesPage />} />
      )}
      <Route path='/pdf-envelopes/:id/envelopes' element={<PdfEnvelopeEntriesPage />} />
      <Route path='/contacts' element={<ContactsPage />} />
      <>
        <Route path='/tickets' element={<AttentionTicketsPage />} />
        <Route path='/tickets/new' element={<TicketFormPage />} />
        <Route path='/tickets/:id' element={<TicketFormPage />} />
        <Route path='/attention-tickets' element={<Navigate to='/tickets' replace />} />
        <Route path='/tickets-atencion' element={<Navigate to='/tickets' replace />} />
      </>
      <Route path='/notifications' element={<NotificationsPageWrapper />} />
      <Route path='/calendar' element={<CalendarPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_RESOURCE_CENTER) && (
        <Route path='/resource-center' element={<ResourceCenterPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_ACADEMY) && (
        <>
          <Route path='/academy' element={<AcademyPage />} />
          <Route path='/academy/:courseId' element={<CoursePlayerPage />} />
          {hasPermission(permissions, ALL_PERMISSIONS.ADD_COURSE) && (
            <Route path='/academy/manage' element={<ManageCoursesPage />} />
          )}
        </>
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_TASKS) && (
        <Route path='/kanban' element={<KanbanPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_CAMPAIGNS) && (
        <>
          <Route path='/campaigns' element={<CampaignsPage />} />
          <Route path='/campaigns/:id' element={<CampaignDetailPage />} />
          <Route path='/campaigns/templates' element={<TemplatesPage />} />
          <Route path='/templates' element={<TemplatesPage />} />
          <Route path='/templates/edit/:id' element={<TemplateEditorPage />} />
          <Route path='/recipients' element={<RecipientsPage />} />
          <Route path='/media-manager' element={<CampaignsMediaPage />} />
          <Route path='/vicidial-campaigns' element={<VicidialCampaignsPage />} />
          <Route path='/auto-push-rules' element={<AutoPushRulesPage />} />
          <Route path='/automations' element={<AutomationsPage />} />
        </>
      )}
      <Route path='/telephony-supervisor' element={<TelephonySupervisorPage />} />
      {/* self-gated inside the page via useTelephony().config.vicidial_enabled */}
      <Route path='/my-calls' element={<MyCallsPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_USER) && (
        <Route path='/system-monitor' element={<SystemMonitorPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICYTOOLS_SETTINGS) && (
        <Route path='/policytools-settings/email' element={<PolicytoolsSettingsPage />} />
      )}
      {/* permission enforced at backend + TelephonySupervisorPage itself */}
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  )
}
